import { Flex, FormLabel, Select, useColorModeValue } from '@chakra-ui/react'
import Card from 'components/card/Card'
import { ChangeEvent, useEffect, useState } from 'react'
import { Account, drawdownChartData, equityChartData, profitWinChartData, Trade } from 'views/trader/trades/variables/types'
import { drawdownValues, equityChartValues, profitFactorWinValues, RValues } from '../../variables/DashChartData'
import DrawdownChart from '../charts/DrawdownChart'
import EquityChart from '../charts/EquityChart'
import ProfitFactorWinChart from '../charts/ProfitFactorWinChart'
import TimeCharts from './TimeCharts'
import { useData } from 'services/data/DataProvider'
import PeriodCharts from './PeriodCharts'
import ChartModal from '../modals/ChartModal'
import RValueChart from '../charts/RValueChart'

const DashCharts = () => {

    const { periodtrades, defaultaccount, defaultgroup, groupAccounts, defaultcurrency, targets } = useData();

    const bdColor = useColorModeValue('gray.200', 'gray.700');
    const [chartType, setChartType] = useState(localStorage.getItem("chart") ? localStorage.getItem("chart") : "time");

    const [equityData, setEquityData] = useState<equityChartData>({ color: "", initBalance: 0, equityChange: 0, series: [{ name: "", data: [], color: "", type: "" }], categories: [] });
    const [profitWinData, setProfitWinData] = useState<profitWinChartData>({ labels: [], categories: [], series: [{ name: '', data: [], color: '', type: '' }] });
    const [drawdownData, setDrawdownData] = useState<drawdownChartData>({ axis: [], series: [{ name: '', data: [], color: '', type: '' }] });
    const [rValueData, setRValueData] = useState<drawdownChartData>({ axis: [], series: [{ name: '', data: [], color: '', type: '' }] });

    const changeChart = (e: ChangeEvent<HTMLSelectElement>) => {
        setChartType(e.target.value);
        localStorage.setItem("chart", e.target.value);
    }

    useEffect(() => {
        periodtrades.sort((a: Trade, b: Trade) => new Date(a.datetime).getTime() - new Date(b.datetime).getTime()); // sort first to last here
        updateVariables();
    }, [periodtrades])

    useEffect(()=>{
        RValues(periodtrades, targets).then((d) => {
            setRValueData(d);
        })
    }, [targets])

    const updateVariables = async () => {
        if (defaultaccount) {
            calculateChartData(periodtrades, [defaultaccount]);
        }
        else {
            calculateChartData(periodtrades, groupAccounts);
        }
    }

    const calculateChartData = (trades: Trade[], accounts: Account[]) => {
        equityChartValues(trades, accounts, defaultaccount, defaultgroup, defaultcurrency).then((d) => {
            setEquityData(d);
        });
        profitFactorWinValues(trades, defaultcurrency).then((d) => {
            setProfitWinData(d);
        })
        drawdownValues(trades, accounts, defaultcurrency).then((d) => {
            setDrawdownData(d);
        })
        RValues(trades, targets).then((d) => {
            setRValueData(d);
        })
    }

    return (
        <>
            {defaultgroup &&
                <Card borderColor={bdColor} borderWidth='1px' h='100%' minH={'500px'} bg='transparent'>
                    <Flex direction={'row'} justify={'space-between'} mb='20px'>
                        <FormLabel fontWeight='bold' fontSize='md' mb='8px'>Charts</FormLabel>
                        <Flex direction={'row'}>
                            <Select size={'sm'} w='150px' borderRadius={'5px'} defaultValue={chartType} onChange={changeChart}>
                                <option value='equity'>Equity Curve</option>
                                <option value='rvalue'>AVG R-Values</option>
                                <option value='period'>Period P/L</option>
                                <option value='time'>Time Analytics</option>
                                <option value='pfwin'>Profit factor Win%</option>
                                <option value='ddown'>Drawdown</option>
                            </Select>
                            <ChartModal />
                            {/*<EquityModal equityChartData={equityData} hidden={chartType !== "equity"} />
                            <ProfitFactorWinModal profitWinData={profitWinData} hidden={chartType !== "pfwin"} />
                            <DrawdownModal drawdownData={drawdownData} hidden={chartType !== "ddown"} />
                            <PeriodModal hidden={chartType !== "period"} />*/}
                        </Flex>
                    </Flex>

                    {chartType === "equity" && <Card h='100%' w='100%' p='0px' bg='transparent'>
                        <EquityChart equityChartData={equityData} hidden={chartType !== "equity"} showtoolbar={true} height={'95%'} />
                    </Card>}
                    {chartType === "pfwin" && <Card h='100%' p='0px' bg='transparent'>
                        <ProfitFactorWinChart profitWinData={profitWinData} hidden={chartType !== "pfwin"} showtoolbar={true} height={'95%'} />
                    </Card>}
                    {chartType === "ddown" && <Card h='100%' p='0px' bg='transparent'>
                        <DrawdownChart drawdownData={drawdownData} hidden={chartType !== "ddown"} showtoolbar={true} height={'95%'} />
                    </Card>}
                    {chartType === "rvalue" && <Card h='100%' p='0px' bg='transparent'>
                        <RValueChart drawdownData={rValueData} hidden={chartType !== "rvalue"} showtoolbar={true} height={'95%'} />
                    </Card>}
                    {chartType === "time" && <TimeCharts hidden={chartType !== "time"} />}
                    {chartType === "period" && <PeriodCharts hidden={chartType !== "period"} minHeight='550px' />}
                </Card>
            }
        </>
    )
}

export default DashCharts